/* ATOMS-INVOICE-MOD-REQ-2025-11 */
class CartInvoiceWOrder extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('#form-invoice-wo-order');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

    this.regimen_array = {
      "Selecciona": "Selecciona",
      601: "Régimen general de ley personas morales",
      602: "Régimen simplificado de ley personas morales",
      603: "Personas morales con fines no lucrativos",
      604: "Régimen de pequeños contribuyentes",
      605: "Régimen de sueldos y salarios e ingresos asimilados a salarios",
      606: "Régimen de arrendamiento",
      607: "Régimen de enajenación o adquisición de bienes",
      608: "Régimen de los demás ingresos",
      609: "Régimen de consolidación",
      610: "Régimen residentes en el extranjero sin establecimiento permanente en méxico",
      611: "Régimen de los ingresos por dividendos (socios y accionistas)",
      612: "Régimen de las personas físicas con actividades empresariales y profesionales",
      613: "Régimen intermedio de las personas físicas con actividades empresariales",
      614: "Régimen de los ingresos por intereses",
      615: "Régimen de los ingresos por obtención de premios",
      616: "Sin obligaciones fiscales",
      617: "Pemex",
      618: "Régimen simplificado de ley personas físicas",
      619: "Ingresos por la obtención de préstamos",
      620: "Sociedades cooperativas de producción que optan por diferir sus ingresos.",
      621: "Régimen de incorporación fiscal",
      622: "Régimen de actividades agrícolas, ganaderas, silvícolas y pesqueras pm",
      623: "Régimen de opcional para grupos de sociedades",
      624: "Régimen de los coordinados",
      625: "Régimen de las actividades empresariales con ingresos a través de plataformas tecnológicas.",
      626: "Régimen simplificado de confianza"
    }
    this.CFDI_array = {
      "Selecciona": "Selecciona",
      "G01": "Adquisición de mercancías",
      "G02": "Devoluciones, descuentos o bonificaciones",
      "G03": "Gastos en general",
      "I01": "Construcciones",
      "I02": "Mobiliario y equipo de oficina para inversiones",
      "I03": "Equipo de transporte",
      "I04": "Equipo de cómputo y accesorios",
      "I05": "Dados, troqueles, moldes, matrices y herramental",
      "I06": "Comunicaciones telefónicas",
      "I07": "Comunicaciones satelitales",
      "I08": "Otra maquinaria y equipo",
      "D01": "Honorarios médicos, dentales y hospitalarios",
      "D02": "Gastos médicos por incapacidad o discapacidad",
      "D03": "Gastos funerales",
      "D04": "Donativos",
      "D05": "Intereses reales pagados por créditos hipotecarios",
      "D06": "Aportaciones voluntarias al SAR",
      "D07": "Primas de seguros de gastos médicos",
      "D08": "Gastos de transportación escolar obligatoria",
      "D09": "Depósitos en cuentas para el ahorro, primas de pensiones",
      "D10": "Pagos por servicios educativos (colegiaturas)",
      "S01": "Sin efectos fiscales",
      "CP01": "Pagos",
      "CN01": "Nómina"
    }
    this.metodo_array = {
      "Selecciona": "Selecciona",
      "04": "Tarjeta de crédito",
      "28": "Tarjeta de débito"
    }
  };

  onSubmitHandler(event) {
    event.preventDefault();
    console.log('boton');
    /* Gets form data */
    const formData = new FormData(event.target);
    const attributes = Object.fromEntries(formData.entries());
    /* Check if the invoice is on */
    const enableInvoice = formData.get('attributes_enable_invoice');
    const postalCode = formData.get('attributes_codigo_postal');
    const postalRFC = formData.get('attributes_rfc');
    const regimen = formData.get('attributes_regimen');
    const CFDI = formData.get('attributes_CFDI');
    const metodo = formData.get('attributes_metodo');

    const postalCodeValidate = this.validatePostalCode(postalCode);
    const postalRFCValidate = this.validateRFC(postalRFC);
    const message = this.querySelector('#invoice-wo-message');
    //const button_text = this.querySelector('.loading-overlay__text');
    //const loading = this.querySelector('.loading-overlay__spinner');
    
    /* Clean message styles*/
    message.textContent = '';
    //button_text.classList.add('hidden');
    //loading.classList.remove('hidden');
    message.classList.remove('is-active');
    message.classList.remove('is-success');

    if (enableInvoice === "true" && postalCodeValidate === true && postalRFCValidate === true && regimen != "Selecciona" && CFDI != "Selecciona" && metodo != "Selecciona" ){
      const dataForm = attributes;

      /* add attributes rfc, cfdi y metodo */
      dataForm.attributes_regimen_text = this.regimen_array[dataForm.attributes_regimen];
      dataForm.attributes_CFDI_text = this.CFDI_array[dataForm.attributes_CFDI];
      dataForm.attributes_metodo_text = this.metodo_array[dataForm.attributes_metodo];
      
      console.log( dataForm );

      /* Update cart with data */
      fetch(`https://cms.sundek.mx/webhook/factura/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Token 03b2997e8ae8ceec4e8daffb13a2d4f952dc46b0' },
        body: JSON.stringify(dataForm),
      })
      .then((response) => {
        console.log('Respuesta WO');
        
        //button_text.classList.remove('hidden');
        //loading.classList.add('hidden');

        message.classList.add('is-active');
        message.classList.add('is-success');
        message.textContent = 'La información está siendo procesada. Te mantendremos informado.';
 
        // limpiar formulario carrito
        event.target.querySelectorAll('input[type="password"], input[type="text"], input[type="number"], input[type="email"]').forEach(input => {
          input.value = '';
        });
        //event.target.querySelectorAll('select').forEach(select => {select.selectedIndex = 0;});
        document.querySelectorAll('select-invoice').forEach(el => el.reset());
        //

        // limpiar formulario drawer carrito
        this.invoice = document.querySelector('cart-invoice');
        var attributes = {};
        attributes = {
          "attributes_enable_invoice": "false",
          "attributes_rfc": null,
          "attributes_name": null,
          "attributes_regimen": null,
          "attributes_CFDI": null,
          "attributes_codigo_postal": null,
          "attributes_metodo": null
        };
        this.invoice.undapteInvoice(attributes, false);
        const checked_button = document.querySelector('#CartDrawer-Invoice');
        const open_invoice = document.querySelector('cart-open-invoice');
        const edit_invoice = document.querySelector('cart-edit-invoice');
        checked_button.checked = false;
        open_invoice.classList.remove('is-hidden');
        edit_invoice.classList.remove('active');
        //
        
        return response.text();
      })
      .catch((e) => {
        console.error(e);
      }).finally(() => {
        //button_text.classList.remove('hidden');
        //loading.classList.add('hidden');
      }); 
    }
    if(postalCodeValidate === false){
      //button_text.classList.remove('hidden');
      //loading.classList.add('hidden');
      
      message.classList.add('is-active');
      message.textContent = 'CP minimo 5 digitos';
    }
    if(postalRFCValidate === false){
      //button_text.classList.remove('hidden');
      //loading.classList.add('hidden');

      message.classList.add('is-active');
      message.textContent = 'RFC 12 digitos a 13 digitos';
    }
    
    if(metodo === "Selecciona"){
      console.log('Selecciona una opción válida en los campos de Método de pago');
      
      message.classList.add('is-active');
      message.textContent = 'Selecciona una opción válida en los campos de Método de pago';
    }
    if(CFDI === "Selecciona"){
      console.log('Selecciona una opción válida en los campos de CFDI');
      
      message.classList.add('is-active');
      message.textContent = 'Selecciona una opción válida en los campos de CFDI';
    }
    if(regimen === "Selecciona"){
      console.log('Selecciona una opción válida en los campos de Régimen');
      
      message.classList.add('is-active');
      message.textContent = 'Selecciona una opción válida en los campos de Régimen';
    }
  }

  validatePostalCode(codigo) {
    const regex = /^\d{5}$/;
    return regex.test(codigo);
  }

  validateRFC(codigo) {
    //const regex = /^.{12,13}$/;
    const regex = /^[A-Z0-9]{12,13}$/;
    return regex.test(codigo);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-invoice',
        selector: '#CartInvoice'
      }
    ];
  }
};

customElements.define('cart-invoice-wo-order', CartInvoiceWOrder);

/* ATOMS-INVOICE-MOD-REQ-2025-11: RFC invoice */
if (!customElements.get('form-rfc-invoice')) {
  customElements.define('form-rfc-invoice', class FormInvoiceRFC extends HTMLElement {
    constructor() {
      super();

      const toggleRFC = this.querySelector('#formIconRFC');
      const inputRFC = this.querySelector('#formInputRFC');

      toggleRFC.addEventListener('click', function (e) {
          // toggle the type attribute
          const type = inputRFC.getAttribute('type') === 'password' ? 'text' : 'password';
          inputRFC.setAttribute('type', type);
          
          // toggle the eye icon class
          this.classList.toggle('is-slash');
      });
    }
  });
  
};

